<elder-single-pane-wrapper>
  @if (item$ | async; as item) {
    <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="workItemDetailTab">
      <!-- Details -->
      <mat-tab label="{{ 'context.details' | translate }}">
        @let processPlan = processPlan$ | async;
        <!-- General -->
        <div class="flex layout-col p-sm scrollable full">
          <form #frm="ngForm" class="flex layout-col gap-lg">
            <div class="flex-none layout-row">
              <span class="flex"></span>
              <button
                mat-icon-button
                name="save"
                [disabled]="!frm.form.valid"
                (click)="onSave($event)"
              >
                <mat-icon>save</mat-icon>
              </button>
              <button
                mat-icon-button
                name="print-preview"
                [matMenuTriggerFor]="printMenu"
                [disabled]="!processPlan"
              >
                <mat-icon>print</mat-icon>
              </button>
              <mat-menu #printMenu="matMenu">
                <button
                  mat-menu-item
                  (click)="onPreviewItemLabel($event)"
                  [disabled]="!processPlan?.labelingSpec?.itemLabel?.enabled"
                >
                  {{ 'labels.item' | translate }}
                </button>
                <button
                  mat-menu-item
                  (click)="onPreviewPieceLabel($event)"
                  [disabled]="!processPlan?.labelingSpec?.itemPieceLabel?.enabled"
                >
                  {{ 'labels.piece' | translate }}
                </button>
              </mat-menu>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="prepareItem()">
                  <mat-icon color="warn">refresh</mat-icon>
                  {{ 'positions.actions.prepare-again' | translate }}
                </button>
                <button mat-menu-item (click)="calculateItemBoms()">
                  <mat-icon color="warn">refresh</mat-icon>
                  {{ 'positions.actions.calculate-boms' | translate }}
                </button>
                <button mat-menu-item (click)="cleanUpPackages()">
                  <mat-icon>cleaning_services</mat-icon>
                  {{ 'positions.actions.clean-up-packages' | translate }}
                </button>
                <button mat-menu-item (click)="emit()">
                  <mat-icon>podcasts</mat-icon>
                  {{ 'positions.actions.emit-again' | translate }}
                </button>
              </mat-menu>
            </div>
            <!-- First Row-->
            <div class="flex-none layout-row gap-xl">
              <!-- First Column -->
              <div class="layout-col">
                <h4 class="text-title-medium">{{ 'context.overview' | translate }}</h4>
                <div class="layout-col gap-xs">
                  <mat-form-field elderFormFieldLabel class="elder-std-form-field p-xs">
                    <mat-label>{{ 'orders.number' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="prodOrderId"
                      [value]="item.prodOrderId"
                      readonly
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel class="elder-std-form-field p-xs">
                    <mat-label>{{ 'positions.state' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="state"
                      [ngModel]="'WorkItemState.' + item.processingState | translate"
                      placeholder="{{ 'positions.state' | translate }}"
                      readonly
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel class="elder-std-form-field p-xs">
                    <mat-label>{{ 'validation.schedule' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="scheduleValidation"
                      placeholder="{{ 'validation.schedule' | translate }}"
                      readonly
                      [ngModel]="'validation.states.' + item.scheduleValidation | translate"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel class="elder-std-form-field p-xs">
                    <mat-label>{{ 'validation.production' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="processValidation"
                      placeholder="{{ 'validation.production' | translate }}"
                      matTooltip="{{ getProcessValidationTooltip(item) }}"
                      readonly
                      [ngModel]="'validation.states.' + item.processValidation | translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <!-- Second Column -->
              <div class="flex layout-col place-center-center p-sm">
                @if (itemImage) {
                  <img
                    class="order-item-image"
                    [src]="itemImage"
                    (error)="onPreviewLoadError($event)"
                    alt="Rendered WorkItem"
                  />
                }
                @if (!itemImage) {
                  <div class="layout-col place-center-center item-image-fallback">
                    <mat-icon class="noselect broken-icon" color="primary">broken_image</mat-icon>
                  </div>
                }
              </div>
              <!-- Third Column -->
              <div class="flex-none layout-col">
                <h4 class="text-title-medium">{{ 'context.details' | translate }}</h4>
                <div class="layout-row gap-sm">
                  <mat-form-field>
                    <mat-label>{{ 'positions.number' | translate }}</mat-label>
                    <input
                      matInput
                      #numberModel="ngModel"
                      type="text"
                      name="number"
                      [ngModel]="item.number"
                      placeholder="{{ 'positions.number' | translate }}"
                      required
                      readonly
                    />
                    @if (numberModel.errors?.['required']) {
                      <mat-error>{{ 'validations.required' | translate }}</mat-error>
                    }
                  </mat-form-field>
                  @if (item?.orderedProduct) {
                    <mat-form-field>
                      <mat-label>{{ 'products.mainProduct' | translate }}</mat-label>
                      <input
                        matInput
                        type="text"
                        name="mainProduct"
                        [ngModel]="producedProduct.materialId"
                        placeholder="{{ 'products.mainProduct' | translate }}"
                        required
                        readonly
                      />
                      <mat-hint>{{ producedProduct?.searchTerm }}</mat-hint>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'context.quantity' | translate }}</mat-label>
                      <elder-quantity-input
                        [name]="'quantity'"
                        [placeholder]="'context.quantity' | translate"
                        [disabled]="!producedProduct"
                        [ngModel]="item.orderedProduct | productSalesQuantity"
                        [min]="0.000000000000001"
                        required
                        readonly
                      >
                      </elder-quantity-input>
                    </mat-form-field>
                  }
                </div>
                <div class="layout-row gap-sm py-sm">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.length' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="dimension-length"
                      [ngModel]="item.dimensions?.length | number: '1.1-1'"
                      readonly
                      placeholder="{{ 'context.length' | translate }}"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.width' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="dimension-width"
                      [ngModel]="item.dimensions?.width | number: '1.1-1'"
                      readonly
                      placeholder="{{ 'context.width' | translate }}"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.height' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="dimension-height"
                      [ngModel]="item.dimensions?.height | number: '1.1-1'"
                      readonly
                      placeholder="{{ 'context.height' | translate }}"
                    />
                  </mat-form-field>
                </div>
                <div class="layout-row gap-sm">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'positions.weight' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="weight"
                      [ngModel]="item.orderedProduct | productSalesUnitWeight | elderQuantity"
                      readonly
                      placeholder="{{ 'positions.weight' | translate }}"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'context.totalWeight' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="total-weight"
                      [ngModel]="item.totalWeight | elderQuantity"
                      readonly
                      placeholder="{{ 'context.totalWeight' | translate }}"
                    />
                  </mat-form-field>
                </div>
                <h4 class="text-title-medium">{{ 'lead-time.title' | translate }}</h4>
                <div class="layout-row gap-sm">
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'lead-time.independent-from-work-hours' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="leadTimePeriod"
                      [ngModel]="calculateTotalIndependentLeadTime(item) | isoDuration: 'dd'"
                      readonly
                      placeholder="{{ 'lead-time.independent-from-work-hours' | translate }}"
                    />
                  </mat-form-field>
                  <mat-form-field elderFormFieldLabel>
                    <mat-label>{{ 'lead-time.dependent-on-work-hours' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="leadTimeDuration"
                      [ngModel]="calculateTotalDependentLeadTime(item) | isoDuration: 'dd:hh:mm'"
                      readonly
                      placeholder="{{ 'lead-time.dependent-on-work-hours' | translate }}"
                    />
                  </mat-form-field>
                </div>
              </div>
              <!-- Third Column -->
              <div class="flex-20 layout-col">
                <h4 class="text-title-medium">Weiteres</h4>
                <div class="layout-col">
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.description' | translate }}</mat-label>
                    <textarea
                      matInput
                      name="description"
                      [ngModel]="item.description"
                      readonly
                      placeholder="{{ 'context.description' | translate }}"
                    ></textarea>
                  </mat-form-field>
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.note' | translate }}</mat-label>
                    <textarea
                      matInput
                      name="note"
                      [ngModel]="item.note"
                      readonly
                      placeholder="{{ 'context.note' | translate }}"
                    ></textarea>
                  </mat-form-field>
                </div>
                <elder-audited-entity [audited]="item" layout="row"> </elder-audited-entity>
              </div>
            </div>
            <!-- Second Row-->
            <div class="flex-none layout-row gap-xl">
              <div class="flex-none layout-col">
                <h4 class="text-title-medium">{{ 'manufacturing.title' | translate }}</h4>
                <div class="layout-row gap-sm">
                  <mat-form-field>
                    <elder-select
                      appProcessPlanSelect
                      [disabled]="item.processingState !== WorkItemState.OPEN"
                      valueAsId
                      [value]="item.processPlanId"
                      (valueChange)="item.processPlanId = $event"
                      (entityChange)="onProcessPlanChange($event)"
                    >
                    </elder-select>
                  </mat-form-field>
                  <mat-checkbox
                    class="align-self-center"
                    [disabled]="item.processingState !== WorkItemState.OPEN"
                    [checked]="item.optimizeAssignment"
                    (change)="onOptimizableChange($event)"
                  >
                    {{ 'optimization.optimizable' | translate }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="layout-col gap-sm">
                <h4 class="text-title-medium">{{ 'packages.packages' | translate }}</h4>
                <div class="layout-row gap-sm">
                  <mat-form-field elderFormFieldLabel class="elder-std-form-field p-xs">
                    <mat-label>{{ 'positions.packagingStateTitle' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      name="packagingState"
                      [value]="'positions.packagingState.' + item.packagingState | translate"
                      readonly
                    />
                  </mat-form-field>

                  <div class="flex layout-row place-center-center gap-xl">
                    <app-work-item-packages
                      [unitBundles]="item.packages"
                      [detailedView]="true"
                      (packageClick)="packageClick($event, item.company)"
                    ></app-work-item-packages>
                  </div>
                </div>
              </div>
            </div>
            <!-- Third Row -->
            <div class="flex-none layout-row gap-xl">
              <div class="flex layout-col">
                <app-item-production-route-detail
                  class="flex"
                  [item]="item"
                  (itemChangedId)="onItemChangedId($event)"
                >
                </app-item-production-route-detail>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>
      <!-- Engineering BOM -->
      <mat-tab [disabled]="isEmptyOrNull(item?.engineeringBom)">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.engineeringBom?.namedItems?.length"
            [matBadgeHidden]="isEmptyOrNull(item?.engineeringBom)"
            [matBadgeOverlap]="false"
            >{{ 'bom.eBom' | translate }}
          </span>
        </ng-template>
        <ng-template matTabContent>
          <app-bom-editor
            class="flex"
            style="overflow: hidden"
            [bom]="item?.engineeringBom"
          ></app-bom-editor>
        </ng-template>
      </mat-tab>
      <!-- Manufacturing BOM -->
      <mat-tab [disabled]="isEmptyOrNull(item?.manufacturingBom)">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.manufacturingBom?.namedItems?.length"
            [matBadgeHidden]="isEmptyOrNull(item?.manufacturingBom)"
            [matBadgeOverlap]="false"
            >{{ 'bom.mBom' | translate }}
          </span>
        </ng-template>
        <ng-template matTabContent>
          <app-bom-editor
            class="flex"
            style="overflow: hidden"
            [bom]="item?.manufacturingBom"
          ></app-bom-editor>
        </ng-template>
      </mat-tab>
      <!-- Consumption BOM -->
      <mat-tab [disabled]="isEmptyOrNull(item?.consumptionBom)">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.consumptionBom?.namedItems?.length ?? '0'"
            [matBadgeHidden]="
              isEmptyOrNull(item?.consumptionBom) &&
              WorkItemUtils.bomIsValid(item?.consumptionBom, item?.processingType)
            "
            [matBadgeColor]="
              WorkItemUtils.bomIsValid(item?.consumptionBom, item?.processingType)
                ? 'primary'
                : 'warn'
            "
            [matBadgeOverlap]="false"
            >{{ 'bom.cBom' | translate }}
          </span>
        </ng-template>
        <ng-template matTabContent>
          <app-bom-editor
            class="flex"
            style="overflow: hidden"
            [bom]="item?.consumptionBom"
          ></app-bom-editor>
        </ng-template>
      </mat-tab>
      <!-- Finished BOM -->
      <mat-tab [disabled]="isEmptyOrNull(item?.finishedBom)">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.finishedBom?.namedItems?.length ?? '0'"
            [matBadgeHidden]="
              isEmptyOrNull(item?.finishedBom) &&
              WorkItemUtils.bomIsValid(item?.finishedBom, item?.processingType)
            "
            [matBadgeColor]="
              WorkItemUtils.bomIsValid(item?.finishedBom, item?.processingType) ? 'primary' : 'warn'
            "
            [matBadgeOverlap]="false"
            >{{ 'bom.fBom' | translate }}
          </span>
        </ng-template>
        <ng-template matTabContent>
          <app-bom-editor
            class="flex"
            style="overflow: hidden"
            [bom]="item?.finishedBom"
          ></app-bom-editor>
        </ng-template>
      </mat-tab>
      <!-- Planned Segments -->
      <mat-tab label="{{ 'plannedSegments.title' | translate }}">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.plannedSegments.length"
            [matBadgeHidden]="item?.plannedSegments.length === 0"
            [matBadgeOverlap]="false"
            >{{ 'plannedSegments.title' | translate }}
          </span>
        </ng-template>
        <ng-template matTabContent>
          <app-item-planned-segments
            [plannedSegments]="item.plannedSegments"
            (requestEnrichment)="requestEnrichment()"
          ></app-item-planned-segments>
        </ng-template>
      </mat-tab>
      <!-- Manufacturing -->
      <mat-tab label="{{ 'manufacturing.title' | translate }}">
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="item?.productionRoute?.sequence?.length"
            [matBadgeHidden]="!item?.productionRoute"
            [matBadgeColor]="WorkItemUtils.segmentsAreValid(item) ? 'primary' : 'warn'"
            [matBadgeOverlap]="false"
            >{{ 'manufacturing.title' | translate }}
          </span>
        </ng-template>
        <app-item-work-segments class="flex" [item]="item"></app-item-work-segments>
      </mat-tab>
    </mat-tab-group>
  }
</elder-single-pane-wrapper>
